/** @format */

import _ from 'lodash'

/**
 * 将数据转为树状结构
 * @param  {Array} data                       源数据
 * @param  {Object} config                    配置参数
 * @param  {Boolean} [isCloneData = true]     是否复制数据，默认为true，如果确认不复制，则会污染源数组，慎重设置为false
 * @param  {String} [idProp='id']             用于匹配的属性
 * @param  {String} [parentProp='parent_id']  指向父节点的属性
 * @param  {String} [childrenProp='children'] 树状结构表示子节点的属性
 * @param  {String|Boolean} [open=false]       当为布尔值时表示是否展开子节点,当为字符串时表示需要展开的节点匹配属性
 * @param  {String|Boolean} [expand='']       展开指定节点
 * @param  {Boolean} [hasLevel=false]         用于给每一个节点添加 level 属性，代表节点当前的层次，从 0 开始计算
 * @param  {String} [selected='']             设置选中节点，根据每个节点的 idProp 设置 selected 属性为 true
 * @param  {Array} [checked = []]             批量设置多选框选中状态
 * @param  {Array} [disabled = []]            批量设置多选框禁用状态
 * @param  {Boolean} [isSort = false]         是否根据节点的index大小进行排序
 * @param  {Boolean} [isReturnhash=false]     是否一并返回树数据的hash，设置后函数将返回 [result, hash]
 * @return {Array}
 */
export default function toTree(
  data,
  {
    idProp = 'id',
    parentProp = 'parent_id',
    childrenProp = 'children',
    indexProp = 'index',
    isCloneData = false,
    selected = '',
    checked = [],
    disabled = [],
    open = false,
    expand = '',
    hasLevel = false,
    isSort = false,
  } = {},
  isReturnhash = false,
) {
  if (!data) return []
  let result = []
  let hash = {}
  let len = data.length
  let hasChecked = !!checked.length
  let hasDisabled = !!disabled.length
  data = isCloneData ? _.cloneDeep(data) : data

  for (let i = 0; i < len; i++) {
    if (!!selected && data[i][idProp] === selected) {
      data[i].selected = true
    }
    if (hasChecked && checked.indexOf(data[i][idProp]) !== -1) {
      data[i].checked = true
    }
    if (hasDisabled && disabled.indexOf(data[i][idProp]) !== -1) {
      data[i].disabled = true
    }
    hash[data[i][idProp]] = data[i]
  }

  const path = [expand]
  if (typeof open === 'string' && open !== '') {
    let parent = hash[open]
    while (parent && parent[parentProp]) {
      path.push(parent[parentProp])
      parent = hash[parent[parentProp]]
    }
  }

  for (let j = 0; j < len; j++) {
    let val = data[j]
    if (typeof open === 'string' && open !== '') {
      val.expand = !!val.expand || path.indexOf(val[idProp]) > -1
    } else {
      val.expand = !!val.expand || !!open
    }
    let hashParent = hash[val[parentProp]]
    if (hashParent) {
      !hashParent[childrenProp] && (hashParent[childrenProp] = [])
      hashParent[childrenProp].push(val)
    } else {
      result.push(val)
    }
  }

  if (hasLevel) {
    setLevel(result, { childrenProp: childrenProp })
  }

  if (isSort) {
    sortTree(result, { childrenProp: childrenProp, indexProp: indexProp })
  }

  if (isReturnhash) {
    return [result, hash]
  }

  return result
}

function setLevel(data, { childrenProp = 'children', count = 0 } = {}) {
  data.forEach(item => {
    item.level = count
    if (item[childrenProp]) {
      setLevel(item[childrenProp], { childrenProp, count: count + 1 })
    }
  })
}

function sortTree(data, { childrenProp = 'children', indexProp = 'index' }) {
  if (!data.length) return
  data.sort((val1, val2) => {
    if (val1[indexProp] > val2[indexProp]) {
      return 1
    } else if (val1[indexProp] < val2[indexProp]) {
      return -1
    } else {
      return 0
    }
  })
  data.forEach(item => {
    if (item[childrenProp]) {
      sortTree(item[childrenProp], { childrenProp, indexProp })
    }
  })
}
